import { Injectable } from '@angular/core';
import { GoogleChartsService } from './google-charts.service';
import { PieChartConfig } from './google-chart.config';

declare var google: any;

@Injectable()
export class GooglePieChartService extends GoogleChartsService {
  constructor() {
    super();
  }

  public BuildPieChart(
    elementInDom: any,
    data: any[],
    config: PieChartConfig
  ): void {
    // console.log('check do i have the id : ', elementInDom);
    const chartFunc = () => {
      /**
       * pass the element from the dom
       * use angular @ViewChild to get the element
       */
      return new google.visualization.PieChart(
        // document.getElementById(elementID)
        elementInDom
      );
    };
    const options = {
      title: config.title,
      pieHole: config.pieHole
    };

    this.buildChart(data, chartFunc, options);
  }
}
